import React, { useMemo, useState } from 'react';
import { Search, Star } from 'lucide-react';

function PriorityDeliveriesTable({ selectedDate, deliveries = [], onTogglePriority }) {
  const [query, setQuery] = useState('');

  const filteredDeliveries = useMemo(() => {
    const term = query.trim().toLowerCase();
    if (!term) return deliveries;

    return deliveries.filter((delivery) => {
      const fields = [
        delivery.id,
        delivery.recipient_name,
        delivery.customer_name,
        delivery.district,
        delivery.address,
      ];
      return fields.some((field) => String(field || '').toLowerCase().includes(term));
    });
  }, [deliveries, query]);

  return (
    <section className="rounded-lg border border-slate-200 bg-white p-4">
      <div className="mb-3 flex flex-wrap items-center justify-between gap-3">
        <h2 className="font-bold text-slate-900">Prioridades del dia</h2>
        <div className="flex items-center gap-3">
          <span className="text-sm text-slate-500">{filteredDeliveries.length} / {deliveries.length}</span>
          <span className="text-sm text-slate-500">{selectedDate}</span>
        </div>
      </div>

      <label className="mb-3 flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-600">
        <Search className="h-4 w-4 text-slate-400" />
        <input
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          placeholder="Buscar por ID, cliente, distrito o direccion"
          className="min-w-0 flex-1 border-0 bg-transparent text-sm text-slate-700 outline-none placeholder:text-slate-400"
        />
      </label>

      <div className="max-h-56 overflow-y-auto">
        <table className="w-full text-left text-sm">
          <thead className="sticky top-0 bg-white text-xs uppercase text-slate-500">
            <tr>
              <th className="py-2">ID</th>
              <th>Distrito</th>
              <th>Slot</th>
              <th>Cliente</th>
              <th>Prioridad</th>
            </tr>
          </thead>
          <tbody>
            {filteredDeliveries.slice(0, 80).map((delivery) => (
              <tr key={delivery.id} className="border-t border-slate-100">
                <td className="py-2 font-bold text-slate-700">{delivery.id}</td>
                <td>{delivery.district || 'Sin distrito'}</td>
                <td>{delivery.slot || 0}</td>
                <td>{delivery.recipient_name}</td>
                <td>
                  <button
                    onClick={() => onTogglePriority(delivery)}
                    className={`inline-flex items-center gap-1 rounded-lg px-2 py-1 text-xs font-bold ${
                      delivery.priority ? 'bg-amber-100 text-amber-700' : 'bg-slate-100 text-slate-500'
                    }`}
                  >
                    <Star className="h-3 w-3" />
                    {delivery.priority ? 'Si' : 'No'}
                  </button>
                </td>
              </tr>
            ))}
            {filteredDeliveries.length === 0 && (
              <tr>
                <td colSpan="5" className="border-t border-slate-100 py-6 text-center text-sm text-slate-500">
                  No se encontraron entregas.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}

export default PriorityDeliveriesTable;
